export default function MobileSection({ title, children }) {
  return (
    <section className="border-b border-primary/30 bg-mgs-bg px-4 py-4">
      {title ? (
        <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-primary">
          {title}
        </h2>
      ) : null}
      {children}
    </section>
  );
}
